import React, { useState } from 'react';
import MainLayout from '../../layout/mainLayout';
import LogoutDialog from './component/logoutDialog';
import {
  Typography,
  Grid,
  Stack,
  Switch,
  Divider,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Link,
} from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { useNavigate } from 'react-router-dom';
import {
  Chart1,
  ChartCircle,
  Task,
  Lock1,
  Moon,
  LogoutCurve,
} from 'iconsax-react';
import { setRoute, setThemeMode } from '../../store/globalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';

const Profile = () => {
  const phoneNumber = JSON.parse(localStorage.getItem('info'))?.mobile_no || '';
  const lastName = JSON.parse(localStorage.getItem('info'))?.last_name || '';
  const firstName = JSON.parse(localStorage.getItem('info'))?.first_name || '';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const themeMode = useSelector((st) => st?.global?.themeMode) || 'light';
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const iconColor = theme.palette.text.primary;

  const handleToggleTheme = () => {
    dispatch(setThemeMode(themeMode === 'dark' ? 'light' : 'dark'));
  };

  const handleEdit = () => {
    navigate('/profile/edit');
  };

  const handleChangePassword = () => {
    navigate('/profile/change-password');
  };

  const handleLogOut = () => {
    setOpenLogoutDialog(true);
  };

  return (
    <MainLayout>
      <LogoutDialog open={openLogoutDialog} setOpen={setOpenLogoutDialog} />
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'background.paper',
          width: '100%',
        }}
      >
        <Typography
          paddingRight={'20px'}
          paddingLeft={'20px'}
          marginTop={'20px'}
          fontSize={20}
          fontWeight={600}
          textAlign={'left'}
        >
          حساب کاربری
        </Typography>
        <Divider
          sx={{
            width: '100%',
            marginTop: '10px',
          }}
        />
      </Stack>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        container
        xs={12}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Grid item mt={4}>
          <Avatar src="/broken-image.jpg" sx={{ width: 80, height: 80 }} />
        </Grid>
        <Grid item mt={2}>
          <Typography fontSize={20} fontWeight={600}>
            {firstName} {lastName}
          </Typography>
        </Grid>
        <Grid item mt={1}>
          <Typography fontSize={16} fontWeight={500} color={'primary.gray'}>
            {phoneNumber}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            onClick={handleEdit}
            sx={{
              width: '100%',
              borderRadius: '8px',
              fontFamily: 'iran-sans-light',
              fontSize: '14px',
              fontWeight: '600',
              marginTop: '16px',
              color: 'primary.contrastText',
            }}
            size="medium"
            variant="contained"
          >
            ویرایش اطلاعات
          </Button>
        </Grid>
        {/* <Grid mt={3} display={'flex'} justifyContent={'center'} width={'100%'}>
          <List
            dense
            sx={{
              bgcolor: 'background.card',
              border: '1px solid',
              borderColor: 'divider',
              width: '100%',
              maxWidth: 360,
              borderRadius: '16px',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <ListItemSecondaryAction
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '8px',
                }}
              >
                <ArrowBackIosNewOutlinedIcon fontSize="24" />
              </ListItemSecondaryAction>
              <ListItemButton
                LinkComponent={Link}
                href="/missions"
                onClick={() => {
                  dispatch(setRoute('missions'));
                }}
              >
                <ChartCircle
                  size="24"
                  color={iconColor}
                  style={{ marginLeft: '8px' }}
                />
                <ListItemText primary={`ماموریت ها`} />
              </ListItemButton>
            </ListItem>
            <Divider
              sx={{
                width: '90%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <ListItemSecondaryAction
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '8px',
                }}
              >
                <ArrowBackIosNewOutlinedIcon fontSize="24" />
              </ListItemSecondaryAction>
              <ListItemButton
                LinkComponent={Link}
                href="/warehouse"
                onClick={() => {
                  dispatch(setRoute('warehouse'));
                }}
              >
                <Task size="24" color={iconColor} style={{ marginLeft: '8px' }} />
                <ListItemText primary={`تحویل به انبار`} />
              </ListItemButton>
            </ListItem>
            <Divider
              sx={{
                width: '90%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <ListItemSecondaryAction
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '8px',
                }}
              >
                <ArrowBackIosNewOutlinedIcon fontSize="24" />
              </ListItemSecondaryAction>
              <ListItemButton
                LinkComponent={Link}
                href="/reports"
                onClick={() => {
                  dispatch(setRoute('reports'));
                }}
              >
                <Chart1
                  size="24"
                  color={iconColor}
                  style={{ marginLeft: '8px' }}
                />
                <ListItemText primary={`گزارشات`} />
              </ListItemButton>
            </ListItem>
          </List>
        </Grid> */}
        <Grid
          mb={3}
          mt={3}
          display={'flex'}
          justifyContent={'center'}
          width={'100%'}
        >
          <List
            dense
            sx={{
              bgcolor: 'background.card',
              border: '1px solid',
              borderColor: 'divider',
              width: '100%',
              maxWidth: 360,
              borderRadius: '16px',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <ListItemSecondaryAction
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Switch
                  checked={themeMode === 'dark'}
                  onChange={handleToggleTheme}
                  onClick={(event) => event.stopPropagation()}
                />
              </ListItemSecondaryAction>
              <ListItemButton onClick={handleToggleTheme}>
                <Moon size="24" color={iconColor} style={{ marginLeft: '8px' }} />
                <ListItemText primary={`حالت شب`} />
              </ListItemButton>
            </ListItem>
            <Divider
              sx={{
                width: '90%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
              }}
              onClick={handleChangePassword}
            >
              <ListItemSecondaryAction
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '8px',
                }}
              >
                <ArrowBackIosNewOutlinedIcon fontSize="24" />
              </ListItemSecondaryAction>
              <ListItemButton>
                <Lock1
                  size="24"
                  color={iconColor}
                  style={{ marginLeft: '8px' }}
                />
                <ListItemText primary={`تغییر رمز عبور`} />
              </ListItemButton>
            </ListItem>
            <Divider
              sx={{
                width: '90%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
            <ListItem
              disablePadding
              sx={{
                justifyContent: 'center',
                display: 'flex',
                color: 'red',
              }}
              onClick={handleLogOut}
            >
              <ListItemButton>
                <LogoutCurve
                  size="24"
                  color="red"
                  style={{ marginLeft: '8px' }}
                />
                <ListItemText primary={`خروج از حساب کاربری`} />
              </ListItemButton>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default Profile;
